import axios from "axios";
import subjectPreparation from "@partials/subject-preparation.handlebars";
import {logger} from "@main/helpers/logger";
import {ApplyModal} from "@main/components/apply-modal";
import {ToggleScroll} from "@main/components/toggle-scroll";

/** Класс модального окна по предмету подготовки. */
class SubjectPreparationModal {
    modal = document.querySelector(".js-modal-subject")

    modalSection = this.modal.querySelector(".js-subject-preparation")
    
    documentEl = document.body
    /**
     * Конструктор класса.
     *
     * @param {HTMLElement} el Элемент.
     */
    constructor(el) {
        this.el = el;
        this.id = this.el.dataset.subjectId;
        this.trainingProgramBlock = this.el.closest(".training-program");
        this.link = this.el.querySelector(".js-subject-study-link");
        this.url = this.trainingProgramBlock?.dataset.url;

        this.listenEvents();
    }

    /**
     * Прослушиваем события.
     * 
     * @returns {void}
     */
    listenEvents() {
        if (window.innerWidth > 1080) {
            this.el.addEventListener("click", () => {
                this.openAndUpdateModal();
            });
        } else {
            this.link.addEventListener("click", (e) => {
                e.preventDefault();
                this.openAndUpdateModal();
            });
        }
        
    }

    /**
     * Получение описания предмета подготовки.
     * 
     * @param {string} id Получение id выбранного предмета.
     * @returns {Promise}
     */
    getSubjectDescription = async (id) => {
        try {
            const {data} = await axios({
                url: this.url,
                method: "GET",
                params: {
                    id,
                }
            });

            return data;
        } catch (e) {
            logger.log(e);
        }
    } 

    /**
     * Обновление контента модального окна.
     * 
     * @returns {void}
     */
    updateModalContent = async (id) => {
        const response = await this.getSubjectDescription(id);
        const data = response.data;
        const card = {
            subject: {
                id: data.id,
                name: data.name,
                text: data.text,
                list: data.list,
            }
        };
        const subjectDescription = subjectPreparation(card);

        this.modalSection.innerHTML = "";
        this.modalSection.insertAdjacentHTML("beforeend", subjectDescription);
    }

    /**
     * Открытие и обновление модального окна.
     * 
     * @returns {void}
     */
    openAndUpdateModal() {
        this.modal.classList.add("shown");
        ToggleScroll.disable(this.modal);

        this.updateModalContent(this.id);
        new ApplyModal(this.modalSection);
    }
}

window.addEventListener("load", () => {
    document.querySelectorAll(".js-subject-study").forEach((item) => new SubjectPreparationModal(item));
});
